import React, {
	useState,
	useContext
} from 'react';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import SearchTabView from './SearchTabView'
import { useTranslation } from "react-i18next";

const SearchView = props => {
	const { t } = useTranslation();
	const [key, setKey] = useState(1)

	const renderPanel = () => {
		var result = [];
		result.push(
			<div>
				<Tabs
					activeKey={key}
					onSelect={setKey}
					id="controlled-tab-example"
				>

					<Tab eventKey={1} title="Schwarzschrift Suche">
						<SearchTabView system={props.system} mode="text" />
					</Tab>
					<Tab eventKey={2} title="Punktschrift Suche">
						<SearchTabView system={props.system} mode="braille" />
					</Tab>

				</Tabs>
			</div>
		)
		return result;
	}

	return (
		<div className='h-100'>
			<h1>Suche {t("common.systems." + props.system)}</h1>
			<div>
				{renderPanel()}
			</div>
		</div>
	)
}
export default SearchView; 